<script setup lang="ts"></script>

<template>
  <router-view />
</template>

<style lang="scss">
// 전역 스타일은 @/shared/styles/index.scss에서 처리됨
</style>
